import { Badge } from "@/components/ui/badge";
import { useMemo } from "react";
//map platform to color

const platformColorMapping = {
  java: "bg-[#007396]",
  spring: "bg-[#6DB33F]",
  springboot: "bg-[#6DB33F]",
  dotnet: "bg-[#512BD4]",
  python: "bg-[#3776AB]",
  nodejs: "bg-[#BE1588]",
  "Node.js": "bg-[#BE1588]",
  go: "bg-[#00ADD8]",
  nestjs: "bg-[#E0234E]",
  react: "bg-[#61DAFB]",
  angular: "bg-[#DD0031]",
  vue: "bg-[#4FC08D]",
  ruby: "bg-[#CC342D]",
  php: "bg-[#777BB4]",
};

const PlatformBadge = ({ platform }) => {
  const backgroundColor = useMemo(
    () =>
      platformColorMapping[platform?.toLowerCase() || ""] ||
      platformColorMapping["java"],
    [platform]
  );
  return (
    <Badge
      variant="default"
      className={`${backgroundColor} text-white text-xs`}
    >
      <span>{platform || "unknown"}</span>
    </Badge>
  );
};
export default PlatformBadge;
